import { intl } from '@fullstory/intl';
import {
  BuiltInDimension,
  Dimension,
  DimensionSettings,
  SortOrder,
  SortType,
} from '@fullstory/proto/fs/api/metrics';
import { DimensionNoConfig, DimensionState } from '../constants';

export type DimensionSettingsNoDimensions = Omit<DimensionSettings, 'dimensions' | 'dimension'>;

export const DEFAULT_DIMENSION: Dimension = {
  builtInProperty: BuiltInDimension.DIMENSION_BROWSER,
  prefix: '',
  limit: 0,
  computeAtLevel: false,
  eventRefinement: null,
};

export const DEFAULT_DIMENSION_SETTINGS: DimensionSettingsNoDimensions = {
  sortOrder: SortOrder.SORT_ORDER_DESC,
  sortByDefault: false,
  sortType: SortType.SORT_TYPE_INVALID,
  limit: 50,
  computeTopLevel: false,
  computeNumGroups: false,
  allowAllPartialResults: false,
  noFallback: false,
};

export const DEFAULT_DIMENSION_SETTINGS_BROWSER: DimensionSettings = {
  dimension: DEFAULT_DIMENSION,
  dimensions: [DEFAULT_DIMENSION],
  sortOrder: SortOrder.SORT_ORDER_DESC,
  sortByDefault: false,
  sortType: SortType.SORT_TYPE_INVALID,
  limit: 50,
  computeTopLevel: false,
  computeNumGroups: false,
  allowAllPartialResults: false,
  noFallback: false,
};

export const DEFAULT_DIMENSION_NO_CONFIG: DimensionNoConfig = {
  builtInProperty: DEFAULT_DIMENSION.builtInProperty,
  prefix: DEFAULT_DIMENSION.prefix,
};

export const DEFAULT_DIMENSION_STATE: DimensionState = {
  dimensions: [DEFAULT_DIMENSION_NO_CONFIG],
  label: intl.formatMessage({ defaultMessage: 'Browser', id: 'E3oB+t' }),
};

export const nullDimensionSettings: DimensionSettings = {
  ...DEFAULT_DIMENSION_SETTINGS,
  dimension: null,
  dimensions: Array.from([]),
} as const;
